import { createActionCreator } from '@pressreader/appstore';
import { IArticle } from '@pressreader/content-types';
import { IPoint } from '@pressreader/geometry';

import { MODULE_NAME } from '../../constants';
import { ArticleActionPayload } from '../../types/article.action.payload';

const prefix = `${MODULE_NAME}/print/`;

export const openPrintMenuAction = createActionCreator<{
    articleId: string;

    center?: IPoint;

    parentMenuId?: string;

    article?: IArticle;
}>(`${prefix}open-print-menu`);

export const articlePrintTextAction = createActionCreator<ArticleActionPayload>(`${prefix}article-print-text`);

export const articlePrintImageAction = createActionCreator<ArticleActionPayload>(`${prefix}article-print-image`);

export const articlePrintPageAction = createActionCreator<ArticleActionPayload>(`${prefix}article-print-page`);
